import { render } from "./Talents.vue?vue&type=template&id=7c15974e&ts=true"
import script from "./Talents.vue?vue&type=script&lang=ts"
export * from "./Talents.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__